import { W as WuiMenuPane$1, d as defineCustomElement$1 } from './menu-pane.js';

const WuiMenuPane = WuiMenuPane$1;
const defineCustomElement = defineCustomElement$1;

export { WuiMenuPane, defineCustomElement };

//# sourceMappingURL=wui-menu-pane.js.map